<template>
    <h4 class="root">
        <slot />
    </h4>
</template>

<script>
export default {
    name: "Title"
}
</script>

<style>
.root {
    margin-bottom: 0;
}
</style>